export class FileUpload {
  link!: string;
  mediaType!: number;
  postTime!: number;
}